import React from "react";
import "./style.css";
function Loading() {
  return (
    <div className="text-center p-4 loading">
      <h3>
        <img id="loading-image" src={window.css_js_manager.loading} />
      </h3>
    </div>
  );
}

export default Loading;
